import onMissingExtension from '../actions/onMissingExtension';
import SmimeInstallationStatus from '../store/schema/SmimeInstallationStatus';
import { getStore } from '../store/store';
import { isSmimeNativeAppInstalledSeparately } from '../utils/smimeUtils';
import { logUsage } from 'owa-analytics';
import { trace } from 'owa-trace';
import { mutator } from 'satcheljs';

export default mutator(onMissingExtension, () => {
    const smimeAdapterStore = getStore();
    smimeAdapterStore.installationStatus = isSmimeNativeAppInstalledSeparately()
        ? SmimeInstallationStatus.MissingExtensionByAdmin
        : SmimeInstallationStatus.MissingExtension;
    trace.warn('S/MIME: Extension missing for browser. UA: ' + navigator.userAgent.toLowerCase());
    logUsage('SmimeMissingExtensionDatapoint', {}, { isCore: true });
});
